import React, { useEffect, useState, useContext } from "react";
import PaginatedTable from "../../components/table";

import { ButtonSelect } from "../../components/form-inputs/inputs";
import { addPermissionToRole, getRole, getRolePermissions, getPermissions, deletePermissionFromRole } from "./lib/roleData";
import { ViewOnlyPermissionsContext } from "contexts/view-only-permissions/view-only-permissions";
import { buildPermissions } from "./lib/constants";
import { useInput } from "../../shared/hooks/form-fields";
import { useParams } from "react-router-dom";

const RolePermissionsIndex = (props) => {
    const params = useParams();
    const { viewOnlyAdmin } = useContext(ViewOnlyPermissionsContext);
    const roleId = params.id;
    const [pulse, setPulse] = useState(false);
    const [role, setRole] = useState({ name: "", description: "" });
    const [permissions, setPermissions] = useState([]);
    const permissionSelect = useInput("");

    const triggerUpdate = () => {
        setPulse(!pulse);
    };

    useEffect(() => {
        async function fetchData() {
            const roleData = await getRole(roleId);
            const permissionData = await getPermissions();

            setRole(roleData);

            if (permissionData) {
                setPermissions(
                    permissionData.items.map((r) => {
                        return { value: r.name, text: r.name };
                    })
                );
            }
        }

        fetchData();
    }, [props.pulse]);

    useEffect(() => {
        async function fetchData() {
            const permissionData = await getPermissions();

            if (permissionData) {
                setPermissions(
                    permissionData.items.map((r) => {
                        return { value: r.name, text: r.name };
                    })
                );
            }
        }

        fetchData();
    }, [pulse]);

    const fetchRolePermissions = (pageNumber, pageSize, sort, filter) => {
        return getRolePermissions(roleId, pageNumber, pageSize, sort, filter);
    };

    const addPermission = () => {
        triggerUpdate(); //TODO: don't like the timing here

        return addPermissionToRole(roleId, permissionSelect.value);
    };

    const deletePermission = (id) => {
        triggerUpdate(); //TODO: don't like the timing here

        return deletePermissionFromRole(roleId, id);
    };

    return (
        <div>
            <h1>{role.name} Role Permissions</h1>
            <p>{role.description}</p>
            <ButtonSelect
                {...permissionSelect.bind}
                label="Add Permission"
                buttonClick={addPermission}
                options={permissions}
                disabled={viewOnlyAdmin.addRolePermissions}
            />
            <br />
            <PaginatedTable
                getData={fetchRolePermissions}
                columns={buildPermissions(deletePermission, viewOnlyAdmin.deleteRolePermissions)}
                filterable={false}
                sortable={false}
                updatePulse={pulse}
            />
        </div>
    );
};

export default RolePermissionsIndex;
